import { useCallback } from 'react';

import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

import apiService from 'services/api/ApiService';
import { StartGameResponse } from 'services/api/definitions/play.definitions';
import { useBadgeNotification, usePointsNotification } from 'services/notifications';

type Params = { id: string; name: string };
export const usePlayGame = (
  options: UseMutationOptions<StartGameResponse, AxiosError, Params> = {},
) => {
  const { showBadgeNotification } = useBadgeNotification();
  const { showNotification } = usePointsNotification();
  const { mutate } = useMutation(({ id, name }) => apiService.startGame(id, name), {
    ...options,
  });

  const startGame = useCallback(
    (params: Params) => {
      mutate(params, {
        onSuccess: data => {
          if (data && !!data.pointsGained.length) {
            data.pointsGained.forEach((notification, idx) => {
              // Because notistack doesn't support queing https://github.com/iamhosseindhv/notistack/issues/204
              // We just delay the notification until the auto hide has been triggered
              setTimeout(() => {
                showNotification(notification, 5000);
              }, 6000 * idx);
            });
          }
          const pointsNotificationsCount = data?.pointsGained.length ?? 0;
          if (data && !!data.badgesEarned?.length) {
            setTimeout(() => {
              data.badgesEarned.forEach(notification => {
                showBadgeNotification(notification);
              });
            }, pointsNotificationsCount * 6000);
          }
        },
      });
    },
    [mutate, showNotification, showBadgeNotification],
  );

  return {
    startGame,
  };
};
